import React, { HTMLAttributes } from 'react';
import { useStoreState } from '@/store';
import { SHAPE_ENUM, SVG_ATTR_ENUM } from '../../types';
import Position from '../position';

interface IProps extends HTMLAttributes<HTMLDivElement> {
    OnClick: (type: SVG_ATTR_ENUM, val: number) => void;
}
const Rect: React.FC<IProps> = (props) => {
    const { style, OnClick } = props;
    const svgInfo = useStoreState((state) => state.svgModel.svgConfig);
    const curShape = useStoreState((state) => state.svgModel.curShape);
    return (
        <React.Fragment>
            {curShape === SHAPE_ENUM.RECT ? (
                <div className="design-svg-panel-rect" style={style}>
                    {/* <Position
                        title="X"
                        type={SVG_ATTR_ENUM.X}
                        pos={svgInfo[curShape].x}
                        onClick={OnClick}
                    />
                    <Position
                        title="Y"
                        type={SVG_ATTR_ENUM.Y}
                        pos={svgInfo[curShape].y}
                        onClick={OnClick}
                    /> */}
                    <Position
                        title="width"
                        type={SVG_ATTR_ENUM.WIDTH}
                        pos={svgInfo[curShape].width}
                        onClick={OnClick}
                    />
                    <Position
                        title="height"
                        type={SVG_ATTR_ENUM.HEIGHT}
                        pos={svgInfo[curShape].height}
                        onClick={OnClick}
                    />
                    <Position
                        title="圆角"
                        type={SVG_ATTR_ENUM.RX}
                        pos={svgInfo[curShape].rx}
                        onClick={OnClick}
                        max={Math.max(svgInfo[curShape].width, svgInfo[curShape].height) / 2}
                    />
                    {/* <Position
                        title="RY(垂直圆角)"
                        type={SVG_ATTR_ENUM.RY}
                        pos={svgInfo[curShape].ry}
                        onClick={OnClick}
                    /> */}
                </div>
            ) : null}
        </React.Fragment>
    );
};
export default React.memo(Rect);
